function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.94658 10.2918C6.73699 8.99099 8.85224 8.21063 11.0585 8.03699C13.2647 7.86336 15.476 8.30321 17.4479 9.30792C19.4197 10.3126 21.0754 11.8431 22.2317 13.73C23.388 15.617 24 17.7869 24 20L18 20C18 18.8935 17.694 17.8085 17.1158 16.865C16.5377 15.9215 15.7099 15.1563 14.7239 14.654C13.738 14.1516 12.6324 13.9317 11.5292 14.0185C10.761 14.0185 9.98971 14.2078 9.21847 14.654L4.94658 10.2918Z",
  fill: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.05583e-05 20C6.04039e-05 18.2336 0.390032 16.4889 1.14213 14.8906C1.89424 13.2923 2.98992 11.8798 4.35097 10.7538L7.67603 15.8555C7.29037 16.2761 6.94715 16.6462 6.5711 17.4453C6.19505 18.2445 6.00006 19.1168 6.00006 20L6.05583e-05 20Z",
  fill: "#C40202"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 19,
  r: 2,
  fill: "#D9D9D9"
});

function SvgCallQualityPoor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallQualityPoor);
export default __webpack_public_path__ + "static/media/call_quality_poor.fde47ba2.svg";
export { ForwardRef as ReactComponent };